import React from 'react';
import { RenderIf } from '../RenderIf';

import {
  BaseButton,
  IconContainer,
  IconSpacer
} from './styles';

export function Button({
  text,
  TrailingIconElement,
  LeadingIconElement,
  loading = false,
  loadingPlaceholder = 'Carregando...',
  onPress,
  mainColor = '#F47C34',
  minorColor = '#FFF',
  type = 'primary',
  disabled
}) {
  const backgroundColor = type === 'primary' ? mainColor : 'transparent';
  const textColor = type === 'primary' ? minorColor : mainColor;

  return (
    <BaseButton
      textColor={textColor}
      backgroundColor={backgroundColor}
      type={type}
      onClick={onPress}
      disabled={loading}
    >
      <RenderIf isTrue={loading}>
        {loadingPlaceholder}
      </RenderIf>
      <RenderIf isTrue={!loading}>
        <RenderIf isTrue={LeadingIconElement}>
          {LeadingIconElement}
          <IconSpacer />
        </RenderIf>
        {text}
        <RenderIf isTrue={TrailingIconElement}>
          <IconSpacer />
          {TrailingIconElement}
        </RenderIf>
      </RenderIf>
    </BaseButton>
  )
}